import { render, staticRenderFns } from "./app_shop_admin copy.vue?vue&type=template&id=3cb4d396&scoped=true&"
import script from "./app_shop_admin copy.vue?vue&type=script&lang=js&"
export * from "./app_shop_admin copy.vue?vue&type=script&lang=js&"
import style0 from "./app_shop_admin copy.vue?vue&type=style&index=0&id=3cb4d396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb4d396",
  null
  
)

export default component.exports